import React, { useEffect, useState } from 'react';
import api from 'helpers/api';
import dateFormatter from 'helpers/date_formatter';
import { useAngularService } from 'helpers/get_angular_service';
import notification from 'helpers/notification';
import Icon from '../../components/icon';
import FeatureNames from 'constants/feature_names';

const ContactFlagsModal = ({ modalInstance, contact }) => {
  const [flags, setFlags] = useState([]);
  const $rootScope = useAngularService('$rootScope');
  const gym = $rootScope.gym;

  useEffect(() => {
    const url = `/gyms/${gym.id}}/contacts/${contact.id}/flags`;
    api.get(url).then(
      (response) => {
        setFlags(response);
      },
      () => {
        notification.error('Request could not be completed. Please try again');
      },
    );
  }, []);

  const cancel = () => {
    modalInstance.dismiss('cancel');
  };

  return (
    <div className="contact-flags-modal">
      <div className="modal-header">
        <h4 className="modal-title">{contact.name}'s Flags</h4>
        <button
          type="button"
          aria-hidden="true"
          className="close-modal"
          onClick={cancel}
          title="Close"
        >
          <i className="icon-cross"></i>
        </button>
      </div>
      <div className="modal-body modal-body-visible">
        <div className="contact-flags-modal__flags">
          {flags.map((flag) => (
            <div key={flag.id} className="flag">
              {flag.color && (
                <div className="flag__color" style={{ backgroundColor: flag.color }} />
              )}

              <div className="flag__row">
                <div className="flag__title">
                  <Icon name="flag" width={18} height={18} color="#F26F21" />
                  {flag.title}
                </div>

                <div className="flag__tags">
                  {flag.tag_list.map((tag, index) => (
                    <span key={index} className="flag__tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>

              <div className="flag__text">{flag.description}</div>
              <div className="flag__date">
                {dateFormatter(flag.created_at, 'mediumDate')} by{' '}
                {flag.created_from_sequence ? FeatureNames.SEQUENCE_LOWERCASE : flag.created_by_name}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

angular.module('gym').value('ContactFlagsModal', ContactFlagsModal);
